<template>
  <div>
    <span @click="search()">
      <Button
        type="primary"
        @click="modal = true"
        v-hasPermission="[
          'configurationManagement:defaultAlarmConfiguration:add_default_alart_configuration',
        ]"
        >{{
          $t(
            "configuration_management.default_alarm_config.addDefaultAlarmConfig"
          )
        }}</Button
      >
    </span>
    <Modal
      v-model="modal"
      :title="
        $t(
          'configuration_management.default_alarm_config.addDefaultAlarmConfig'
        )
      "
      @on-cancel="cancel('defaultAlarmConfigurationForm')"
      @on-ok="ok('defaultAlarmConfigurationForm')"
      :loading="loading"
      :mask-closable="false"
      width="1000px"
      :okText="$t('configuration_management.default_alarm_config.addAlarm')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="defaultAlarmConfigurationForm"
        :model="defaultAlarmConfigurationForm"
        :label-width="120"
        :rules="ruleValidate"
      >
        <!-- 云平台 -->
        <FormItem
          :label="
            $t('configuration_management.default_alarm_config.cloudPlatform')
          "
          prop="cloudPlatform"
        >
          <Select
            filterable
            @on-change="
              changeCloudPlatform(defaultAlarmConfigurationForm.cloudPlatform)
            "
            v-model="defaultAlarmConfigurationForm.cloudPlatform"
            style="width: 300px"
            :placeholder="$t('resourceLifecycle.pleaseSelect')"
          >
            <Option
              :value="item.id"
              v-for="item in platformList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 监控模块 -->
        <FormItem
          :label="$t('configuration_management.common.monitorModule')"
          prop="monitorModule"
        >
          <Select
            filterable
            @on-change="
              changeMonitorModule(defaultAlarmConfigurationForm.monitorModule)
            "
            :placeholder="$t('resourceLifecycle.pleaseSelect')"
            v-model="defaultAlarmConfigurationForm.monitorModule"
            style="width: 300px"
          >
            <Option
              :value="item.id"
              v-for="item in monitorModuleList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <div v-if="this.isBilling == 1">
          <!-- 类型 -->
          <FormItem
            :label="$t('configuration_management.common.type')"
            prop="types"
          >
            <RadioGroup
              v-model="defaultAlarmConfigurationForm.types"
              @on-change="changeTypes"
            >
              <Radio
                v-for="list in typesList"
                :label="list.types"
                :key="list.value"
                >{{ list.label }}</Radio
              >
            </RadioGroup>
          </FormItem>
          <!-- 资源类型 -->
          <FormItem
            :label="$t('configuration_management.common.resourceType')"
            prop="resourceType"
          >
            <Select
              filterable
              v-model="defaultAlarmConfigurationForm.resourceType"
              style="width: 300px"
              :transfer="true"
              :placeholder="$t('resourceLifecycle.pleaseSelect')"
              @on-change="changeResourceType"
            >
              <Option
                :value="item.id"
                v-for="item in resourceTypeList"
                :key="item.id"
              >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>

        <!-- 规则描述 -->
        <FormItem
          :label="$t('configuration_management.common.ruleDescription')"
        >
          <Row :gutter="4">
            <!-- 监控指标 -->
            <Col span="4">
              <FormItem prop="monitorIndex">
                <Select
                  filterable
                  v-model="defaultAlarmConfigurationForm.monitorIndex"
                  :placeholder="$t('resourceLifecycle.pleaseSelect')"
                  @on-change="
                    changeMonitorIndex(
                      defaultAlarmConfigurationForm.monitorIndex
                    )
                  "
                >
                  <Option
                    :value="item.id"
                    v-for="item in monitorIndexList"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 周期 -->
            <Col span="3">
              <FormItem prop="cycle">
                <Select
                  filterable
                  v-model="defaultAlarmConfigurationForm.cycle"
                  :placeholder="$t('configuration_management.common.cycle')"
                  @on-change="changeCycle(defaultAlarmConfigurationForm.cycle)"
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in cycleList"
                    v-bind:key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 连续周期 -->
            <Col span="3">
              <FormItem prop="continousCycle">
                <Select
                  filterable
                  v-model="defaultAlarmConfigurationForm.continousCycle"
                  :placeholder="
                    $t('configuration_management.common.continuous')
                  "
                  @on-change="
                    changeContinousCycle(
                      defaultAlarmConfigurationForm.continousCycle
                    )
                  "
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in continousCycleList"
                    v-bind:key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 统计数值 -->
            <Col span="3">
              <FormItem prop="statisticsValue">
                <Select
                  filterable
                  v-model="defaultAlarmConfigurationForm.statisticsValue"
                  :placeholder="
                    $t('configuration_management.common.statisticsValue')
                  "
                  @on-change="
                    changeStatisticsValue(
                      defaultAlarmConfigurationForm.statisticsValue
                    )
                  "
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in statisticsValueList"
                    v-bind:key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 统计次数 -->
            <!-- 当账号为"Azure"且监控模块为"实例"且统计数值为"最大值"时  显示统计次数下拉框 -->
            <!-- 当账号为"Aliyun"且监控模块为"实例"且为CPU使用率时  显示统计次数下拉框 -->
            <div
              v-if="
                (defaultAlarmConfigurationForm.cloudPlatform == 2 &&
                  defaultAlarmConfigurationForm.monitorModule == 0 &&
                  defaultAlarmConfigurationForm.statisticsValue == 3) ||
                (defaultAlarmConfigurationForm.cloudPlatform == 2 &&
                  defaultAlarmConfigurationForm.monitorModule == 0 &&
                  defaultAlarmConfigurationForm.statisticsValue == 0) ||
                (defaultAlarmConfigurationForm.cloudPlatform == 1 &&
                  defaultAlarmConfigurationForm.monitorModule == 0 &&
                  defaultAlarmConfigurationForm.statisticsValue == 0) ||
                (defaultAlarmConfigurationForm.cloudPlatform == 0 &&
                  defaultAlarmConfigurationForm.monitorModule == 0 &&
                  defaultAlarmConfigurationForm.statisticsValue == 0)
              "
            >
              <Col span="3">
                <FormItem prop="statisticsCount">
                  <Select
                    filterable
                    v-model="defaultAlarmConfigurationForm.statisticsCount"
                    :placeholder="
                      $t('configuration_management.common.statisticsCount')
                    "
                    @on-change="
                      changeStatisticsCount(
                        defaultAlarmConfigurationForm.statisticsCount
                      )
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in statisticsCountList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </div>

            <div v-if="isNotIOPS">
              <!-- 关系符号 -->
              <Col span="2">
                <FormItem prop="relationshipSign">
                  <Select
                    filterable
                    v-model="defaultAlarmConfigurationForm.relationshipSign"
                    @on-change="
                      changeRelationshipSign(
                        defaultAlarmConfigurationForm.relationshipSign
                      )
                    "
                    :placeholder="$t('configuration_management.common.sign')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in relationshipSignList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <!-- 阈值 -->
              <Col
                span="5"
                v-if="defaultAlarmConfigurationForm.monitorIndex == 40"
              >
                <FormItem prop="thresholdValues">
                  <Select
                    filterable
                    v-model="defaultAlarmConfigurationForm.thresholdValues"
                    filterable
                    multiple
                    allow-create
                    @on-create="handleCreate"
                    :placeholder="
                      $t('configuration_management.common.threshold')
                    "
                    @input="limitcount"
                  >
                    <Option
                      v-for="item in thresholdValuesList"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.label }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <!-- 阈值 -->
              <Col span="3" v-else>
                <FormItem prop="thresholdValue">
                  <Input
                    v-model="defaultAlarmConfigurationForm.thresholdValue"
                    :placeholder="
                      $t('configuration_management.common.threshold')
                    "
                    type="number"
                  ></Input>
                </FormItem>
              </Col>

              <!-- 单位 -->
              <Col span="2">
                <FormItem prop="unit">
                  <Input
                    v-model="defaultAlarmConfigurationForm.unit"
                    disabled
                    :placeholder="$t('configuration_management.common.unit')"
                  ></Input>
                </FormItem>
              </Col>
            </div>
            <div v-if="isIOPS">
              <!-- 关系符号 -->
              <Col span="2">
                <FormItem prop="relationshipSign">
                  <Select
                    filterable
                    v-model="defaultAlarmConfigurationForm.relationshipSign"
                    @on-change="
                      changeRelationshipSign(
                        defaultAlarmConfigurationForm.relationshipSign
                      )
                    "
                    :placeholder="$t('configuration_management.common.sign')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in relationshipSignList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 阈值 -->
              <Col span="2">
                <div>
                  {{ $t("configuration_management.common.standardValues") }}
                </div>
              </Col>
              <!-- 单位 -->
              <Col span="2">
                <FormItem prop="unit">
                  <Input
                    v-model="defaultAlarmConfigurationForm.unit"
                    disabled
                    :placeholder="$t('configuration_management.common.unit')"
                  ></Input>
                </FormItem>
              </Col>
            </div>
          </Row>
        </FormItem>

        <!-- 当监控模块为“CloudTrail”时 显示事件检查 -->
        <FormItem
          :label="this.$t('alarms.log.cloudTrail.eventCheck')"
          prop="cloudTrailNames"
          v-if="defaultAlarmConfigurationForm.monitorModule == 9"
        >
          <Select
            filterable
            @on-change="
              changeCloudTrailNames(
                defaultAlarmConfigurationForm.cloudTrailNames
              )
            "
            :placeholder="this.$t('alarms.common.pleaseSelect')"
            v-model="defaultAlarmConfigurationForm.cloudTrailNames"
            multiple
            :max-tag-count="1"
            :transfer="true"
            style="width: 300px"
          >
            <Checkbox
              v-model="singleCloudTrailNames"
              @on-change="selectCloudTrailNamesAll"
              style="display: block; text-align: right"
              >{{ $t("alarms.common.all") }}</Checkbox
            >
            <Option
              :value="item.awsEventName"
              v-for="(item, index) in cloudTrailNamesList"
              :key="index"
              >{{ item.awsEventName }}</Option
            >
          </Select>
        </FormItem>

        <!-- 当指标为"EIP没有EC2attached"、"自动购买预留实例"、"没有EBS attached"、"负载均衡未关联实例"时 显示审批流 -->
        <FormItem
          :label="$t('approvalFlowConfigManagement.approvalFlow.title')"
          prop="approvalFlow"
          v-if="
            defaultAlarmConfigurationForm.monitorIndex == 12 ||
            defaultAlarmConfigurationForm.monitorIndex == 35 ||
            defaultAlarmConfigurationForm.monitorIndex == 36 ||
            defaultAlarmConfigurationForm.monitorIndex == 40
          "
        >
          <Select
            filterable
            v-model="defaultAlarmConfigurationForm.approvalFlow"
            style="width: 300px"
            :transfer="true"
            :placeholder="$t('resourceLifecycle.pleaseSelect')"
          >
            <Option
              :value="item.id"
              v-for="(item, index) in approvalFlowList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <div v-show="isShowLogGroupName">
          <FormItem
            :label="$t('configuration_management.common.logGroupName')"
            prop="logGroupName"
            style="width: 300px"
          >
            <Input
              v-model="logGroupName"
              :placeholder="$t('configuration_management.common.logGroupName')"
            ></Input>
          </FormItem>
        </div>
        <!-- 优先级 -->
        <FormItem
          :label="$t('configuration_management.common.priority')"
          prop="priority"
        >
          <Select
            filterable
            v-model="defaultAlarmConfigurationForm.priority"
            style="width: 300px"
            :placeholder="$t('resourceLifecycle.pleaseSelect')"
          >
            <Option
              :value="item.id"
              v-for="item in priorityList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 监控时间段 -->
        <FormItem
          :label="$t('configuration_management.common.monitorPeriod')"
          prop="monitorPeriod"
        >
          <Select
            filterable
            v-model="defaultAlarmConfigurationForm.monitorPeriod"
            style="width: 300px"
            :placeholder="$t('resourceLifecycle.pleaseSelect')"
          >
            <Option
              :value="item.id"
              v-for="item in monitorPeriodList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 报警方式 -->
        <FormItem
          :label="$t('configuration_management.common.alarmWayList')"
          prop="noticeTypes"
        >
          <Select
            filterable
            v-model="defaultAlarmConfigurationForm.noticeTypes"
            multiple
            style="width: 300px"
            :placeholder="$t('resourceLifecycle.pleaseSelect')"
          >
            <Option
              v-for="item in alarmWayList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 是否需要Enroll -->
        <FormItem
          :label="
            $t('configuration_management.common.isAutoDelayEnrollTypeList')
          "
          prop="isAutoDelayEnroll"
        >
          <RadioGroup v-model="defaultAlarmConfigurationForm.isAutoDelayEnroll">
            <Radio
              v-for="list in isAutoDelayEnrollTypeList"
              :label="list.isAutoDelayEnroll"
              :key="list.value"
              >{{ list.label }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import { filterOutDeprecatedMetrics } from "../../../../utils/deprecatedMetrics.js";
import {
  CLOUD_PLATFORM_ID,
  buildPlatformOptions
} from "../../../../utils/cloudPlatform.js";
import TableDefaultAlarmConfiguration from "../default_alarm_configuration/TableDefaultAlarmConfiguration.vue";
var tableDefaultAlarmConfiguration = TableDefaultAlarmConfiguration;
var tableDefaultAlarmConfigurationWarningVue = {};
export default {
  inject: ["reload"],
  data() {
    // 当监控指标为“自动购买预留实例”时 阈值要满足1-6个数字至少有一个大于七 换种实现方式为“第一个阈值必需要大于7” 则满足以上需求
    const validKeyWordsRule = (rule, value, callback, options) => {
      if (value[0] < 7) {
        callback(new Error(this.$t("configuration_management.default_alarm_config.firstThresholdGreaterThan7")));
      } else {
        callback();
      }
    };
    return {
      noticeTypes: [],
      alarmWayList: [],
      isShowLogGroupName: false,
      logGroupName: "",
      singleCloudTrailNames: false,
      cloudTrailNamesList: [],
      platformList: buildPlatformOptions([
        CLOUD_PLATFORM_ID.AWS,
        CLOUD_PLATFORM_ID.ALIYUN,
        CLOUD_PLATFORM_ID.AZURE,
        CLOUD_PLATFORM_ID.GCP,
        CLOUD_PLATFORM_ID.TENCENT
      ]),
      accountTypeList: [],
      thresholdValuesList: [],
      isIOPS: false,
      isNotIOPS: true,
      isBilling: "",
      selection: [],
      loading: true,
      modal: false,
      units: "",
      unit: "",
      typesList: [
        {
          label: this.$t("common.singleAccount"),
          value: "account",
          types: 0,
        },
        {
          label: this.$t("common.accountGroup"),
          value: "accountGroup",
          types: 1,
        },
      ],
      isAutoDelayEnrollTypeList: [
        {
          label: this.$t("companyManagement.yes"),
          value: "true",
          isAutoDelayEnroll: "true",
        },
        {
          label: this.$t("companyManagement.no"),
          value: "false",
          isAutoDelayEnroll: "false",
        },
      ],
      approvalFlowList: [],
      defaultAlarmConfigurationForm: {
        thresholdValue: "",
        monitorIndex: "",
        cycle: "",
        continousCycle: "",
        statisticsValue: "",
        statisticsCount: "",
        relationshipSign: "",
        unit: "",
        monitorModule: "",
        priority: "",
        monitorPeriod: "",
        resourceType: "",
        isAutoDelayEnroll: "true",
        types: 0,
        thresholdValues: [],
        cloudPlatform: "",
        approvalFlow: "",
        noticeTypes: [],
        cloudTrailNames: [],
      },
      // 资源类型
      resourceTypeList: [],
      // 优先级别
      priorityList: [
        {
          id: 0,
          name: "P1",
          priority: "0",
        },
        {
          id: 1,
          name: "P2",
          priority: "1",
        },
        {
          id: 2,
          name: "P3",
          priority: "2",
        },
        {
          id: 3,
          name: "P4",
          priority: "3",
        },
      ],
      // 监控模块
      monitorModuleList: [],
      // 监控时间段
      monitorPeriodList: [],
      // 监控指标
      monitorIndexList: [],
      // 周期
      cycleList: [],
      // 连续周期
      continousCycleList: [],
      // 统计数值
      statisticsValueList: [],
      // 统计次数
      statisticsCountList: [],
      // 关系符号
      relationshipSignList: [],
      ruleValidate: {
        monitorIndex: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectMonitorIndex"),
            trigger: "change",
            type: "number",
          },
        ],
        cycle: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectCycle"),
            trigger: "change",
            type: "number",
          },
        ],
        continousCycle: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectContinousCycle"),
            trigger: "change",
            type: "number",
          },
        ],
        statisticsValue: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectStatisticsValue"),
            trigger: "change",
            type: "number",
          },
        ],
        statisticsCount: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectStatisticsCount"),
            trigger: "change",
            type: "number",
          },
        ],
        relationshipSign: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectRelationshipSign"),
            trigger: "change",
            type: "number",
          },
        ],
        thresholdValue: [{ required: false, message: this.$t("configuration_management.common.pleaseEnterThreshold") }],
        monitorModule: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectMonitorIndex"),
            trigger: "change",
            type: "number",
          },
        ],
        cloudPlatform: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectCloudPlatform"),
            trigger: "change",
            type: "number",
          },
        ],
        priority: [
          {
            required: true,
            message: this.$t("configuration_management.common.pleaseSelectPriority"),
            trigger: "change",
            type: "number",
          },
        ],
        monitorPeriod: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectMonitorPeriod"),
            trigger: "change",
            type: "number",
          },
        ],
        resourceType: [
          {
            required: true,
            message: this.$t("configuration_management.common.pleaseSelectResourceType"),
            trigger: "change",
            type: "number",
          },
        ],
        isAutoDelayEnroll: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectAutoDelayEnroll"),
            trigger: "change",
          },
        ],
        types: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectType"),
            trigger: "change",
            type: "number",
          },
        ],
        thresholdValues: [
          { required: true, type: "array", message: this.$t("configuration_management.common.pleaseSelectThreshold") },
          { validator: validKeyWordsRule },
        ],
        approvalFlow: [
          {
            required: true,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectApprovalFlow"),
            trigger: "change",
            type: "number",
          },
        ],
        noticeTypes: [
          {
            required: true,
            type: "array",
            min: 1,
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectAlarmWay"),
            trigger: "change",
          },
        ],
        cloudTrailNames: [
          {
            required: true,
            type: "array",
            message: this.$t("configuration_management.default_alarm_config.pleaseSelectEventCheck"),
            trigger: "change",
          },
        ],
      },
    };
  },

  beforeCreate: function () {
    tableDefaultAlarmConfigurationWarningVue = this;
  },
  methods: {
    // 控制阈值 最多选择6个阈值
    limitcount(e) {
      if (e.length > 6) {
        this.$Modal.warning({
          title: this.$t("configuration_management.customized_alarm_config.validationRule"),
          content: this.$t("configuration_management.customized_alarm_config.maxSixThresholds"),
        });
        e.pop();
      }
    },
    // 创建阈值
    handleCreate(val) {
      if (val >= 2 && val <= 60) {
        this.thresholdValuesList.push({
          value: val,
          label: val,
        });
      } else {
        this.defaultAlarmConfigurationForm.thresholdValues = [];
        this.$Modal.warning({
          title: this.$t("configuration_management.customized_alarm_config.validationRule"),
          content: this.$t("configuration_management.customized_alarm_config.thresholdRangeForAutoRI"),
        });
      }
    },
    // 切换类型
    searchAccountType: function () {
      this.defaultAlarmConfigurationForm.monitorModule = "";
    },
    // 切换账单类型
    changeTypes: function () {
      this.defaultAlarmConfigurationForm.monitorIndex = "";
      // 查询监控指标
      tableDefaultAlarmConfigurationWarningVue.searchBillingDefaultMonitorIndex();
    },
    // 切换云平台
    changeCloudPlatform: function () {
      this.defaultAlarmConfigurationForm.monitorIndex = "";
      if (this.defaultAlarmConfigurationForm.cloudPlatform == undefined) {
        return;
      }
      // 如果监控模块为账务 显示资源类型
      if (this.defaultAlarmConfigurationForm.monitorModule == 2) {
        this.isBilling = 1;
        tableDefaultAlarmConfigurationWarningVue.searchResourceType();
      } else {
        this.isBilling = "";
        tableDefaultAlarmConfigurationWarningVue.searchMonitorIndex();
      }
    },
    // 查询监控模块
    searchMonitorModule: function () {
      this.$api.alertRule
        .searchMonitorModuleByDefault("userName", getCookie(global.cookieName))
        .then((res) => {
          this.monitorModuleList = res.data;
        });
    },
    // 查询监控时间段
    searchMonitorPeriod: function () {
      this.$api.alertRule
        .monitorPeriod("userName", getCookie(global.cookieName))
        .then((res) => {
          this.monitorPeriodList = res.data;
        });
    },
    // 查询资源类型
    searchResourceType: function () {
      tableDefaultAlarmConfigurationWarningVue.$api.billing
        .searchResourceType("cloudType", tableDefaultAlarmConfigurationWarningVue.defaultAlarmConfigurationForm.cloudPlatform)
        .then((res) => {
          this.resourceTypeList = res.data;
        });
    },
    // 查询
    changeResourceType() {
      tableDefaultAlarmConfigurationWarningVue.$api.billing
        .searchBillMonitorIndex({
          type: this.defaultAlarmConfigurationForm.cloudPlatform,
          billingType: this.defaultAlarmConfigurationForm.types,
          resourceType: this.defaultAlarmConfigurationForm.resourceType
        })
        .then(res => {
          // 隐藏已下线的废弃指标
          this.monitorIndexList = filterOutDeprecatedMetrics(res.data || []);
        });
    },
    // 查询监控指标
    searchMonitorIndex: function () {
      tableDefaultAlarmConfigurationWarningVue.$api.alertRule
        .searchDefaultMonitorIndexByCloudPlatform({
          monitorModule: this.defaultAlarmConfigurationForm.monitorModule,
          cloudPlatform: this.defaultAlarmConfigurationForm.cloudPlatform,
        })
        .then((res) => {
          // 隐藏已下线的废弃指标
          this.monitorIndexList = filterOutDeprecatedMetrics(res.data || []);
        });
    },
    // 查询账单监控指标
    searchBillingDefaultMonitorIndex: function () {
      tableDefaultAlarmConfigurationWarningVue.$api.alertRule
        .searchBillingDefaultMonitorIndex(
          "defaultAlarmAccountType",
          this.defaultAlarmConfigurationForm.types
        )
        .then((res) => {
          // 隐藏已下线的废弃指标
          this.monitorIndexList = filterOutDeprecatedMetrics(res.data || []);
        });
    },
    search: function () {
      tableDefaultAlarmConfigurationWarningVue.searchMonitorModule();
      tableDefaultAlarmConfigurationWarningVue.searchMonitorPeriod();
      tableDefaultAlarmConfigurationWarningVue.searchAlarmWay();
    },
    /***********事件检查**************************/
    selectCloudTrailNamesAll() {
      this.defaultAlarmConfigurationForm.cloudTrailNames = [];
      if (this.singleCloudTrailNames) {
        this.cloudTrailNamesList.map((item) => {
          this.defaultAlarmConfigurationForm.cloudTrailNames.push(
            item.awsEventName
          );
        });
      } else {
        this.defaultAlarmConfigurationForm.cloudTrailNames = [];
      }
    },
    // 查询CloudTrail事件
    queryCloudTrailSecurityEvents: function () {
      this.$api.cloudTrail.queryCloudTrailSecurityEvents().then((res) => {
        this.cloudTrailNamesList = res.data;
      });
    },
    // 切换事件检查
    changeCloudTrailNames: function (val) {
      if (val.length === this.cloudTrailNamesList.length && val.length != 0) {
        this.singleCloudTrailNames = true;
      } else {
        this.singleCloudTrailNames = false;
      }
    },
    // 清空周期、连续周期、统计数值、关系符号
    /****************************************************************/
    emptyDate: function () {
      this.defaultAlarmConfigurationForm.cycle = "";
      this.defaultAlarmConfigurationForm.continousCycle = "";
      this.defaultAlarmConfigurationForm.statisticsValue = "";
      this.defaultAlarmConfigurationForm.relationshipSign = "";
      this.defaultAlarmConfigurationForm.thresholdValue = "";
    },
    isNotEmpty: function (obj) {
      if (typeof obj === "undefined" || obj === null || obj === "") {
        return false;
      } else {
        return true;
      }
    },
    // 根据监控指标 显示不同单位
    changeMonitorIndex: function () {
      // 查找当前选中的指标项
      var selectedItem = null;
      for (var i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id == this.defaultAlarmConfigurationForm.monitorIndex) {
          selectedItem = this.monitorIndexList[i];
          break;
        }
      }

      // 事件类指标（无单位）不需要填写阈值：如 AWS 实例健康状态检查、腾讯云 CVM 维修任务等
      if (
        this.defaultAlarmConfigurationForm.monitorIndex == 15 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 7 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 8 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 10 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 32 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 36 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 61 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 62 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 56 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 54 ||
        (selectedItem && !selectedItem.unit)
      ) {
        this.isIOPS = false;
        this.isNotIOPS = false;
      } else if (
        this.defaultAlarmConfigurationForm.monitorIndex == 30 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 31 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 34 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 28 ||
        this.defaultAlarmConfigurationForm.monitorIndex == 29
      ) {
        this.isIOPS = true;
        this.isNotIOPS = false;
      } else {
        this.isNotIOPS = true;
        this.isIOPS = false;
      }

      if (this.defaultAlarmConfigurationForm.monitorIndex == 59) {
        this.isShowLogGroupName = true;
      } else {
        this.isShowLogGroupName = false;
        this.logGroupName = "";
      }

      // 查询阈值
      tableDefaultAlarmConfigurationWarningVue.selectMonitorIndexDefault();
      this.unit = this.defaultAlarmConfigurationForm.monitorIndex;

      for (var i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id == this.unit) {
          this.defaultAlarmConfigurationForm.unit =
            this.monitorIndexList[i].unit;
          this.units = this.monitorIndexList[i].id;
        }
      }
      tableDefaultAlarmConfigurationWarningVue.emptyDate();
      tableDefaultAlarmConfigurationWarningVue.listProcessTemplatesByMetricIndex();
    },
    // 查询审批流列表
    listProcessTemplatesByMetricIndex: function () {
      if (this.defaultAlarmConfigurationForm.monitorIndex == undefined) {
        return;
      }
      tableDefaultAlarmConfigurationWarningVue.$api.processTemplate
        .listProcessTemplatesByMetricIndex(
          "metricIndex",
          this.defaultAlarmConfigurationForm.monitorIndex
        )
        .then((res) => {
          this.approvalFlowList = res.data;
        });
    },
    // 查询阈值
    /****************************************************************/
    selectMonitorIndexDefault: function () {
      tableDefaultAlarmConfigurationWarningVue.$api.alertRule
        .selectMonitorIndexDefault({
          monitorIndex: this.defaultAlarmConfigurationForm.monitorIndex,
          monitorModule: this.defaultAlarmConfigurationForm.monitorModule,
          cycle: this.defaultAlarmConfigurationForm.cycle,
          continousCycle: this.defaultAlarmConfigurationForm.continousCycle,
          statisticsValue: this.defaultAlarmConfigurationForm.statisticsValue,
          statisticsCount: this.defaultAlarmConfigurationForm.statisticsCount,
          relationshipSign: this.defaultAlarmConfigurationForm.relationshipSign,
          accountId: this.defaultAlarmConfigurationForm.account,
          monitorMode: 0
        })
        .then((res) => {
          // 周期
          this.cycleList = res.data.cycleMap;
          // 连续周期
          this.continousCycleList = res.data.continousCycleMap;
          // 统计数值
          this.statisticsValueList = res.data.statisticsValueMap;
          // 统计次数
          this.statisticsCountList = res.data.statisticsCountMap;
          // 关系符号
          this.relationshipSignList = res.data.relationshipSignMap;
          // 阈值
          if (
            res.data.companyMonitoritemVariablesList.length == 1 &&
            tableDefaultAlarmConfigurationWarningVue.isNotEmpty(
              this.defaultAlarmConfigurationForm.cycle
            ) &&
            tableDefaultAlarmConfigurationWarningVue.isNotEmpty(
              this.defaultAlarmConfigurationForm.continousCycle
            ) &&
            tableDefaultAlarmConfigurationWarningVue.isNotEmpty(
              this.defaultAlarmConfigurationForm.statisticsValue
            ) &&
            tableDefaultAlarmConfigurationWarningVue.isNotEmpty(
              this.defaultAlarmConfigurationForm.statisticsCount
            ) &&
            tableDefaultAlarmConfigurationWarningVue.isNotEmpty(
              this.defaultAlarmConfigurationForm.relationshipSign
            ) &&
            this.defaultAlarmConfigurationForm.id == 0
          ) {
            this.defaultAlarmConfigurationForm.thresholdValue =
              res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
          }
        });
    },

    /**************************************  查询  **************************************/

    // 周期
    changeCycle: function () {
      // 查询阈值
      tableDefaultAlarmConfigurationWarningVue.selectMonitorIndexDefault();
    },
    // 连续周期
    changeContinousCycle: function () {
      // 查询阈值
      tableDefaultAlarmConfigurationWarningVue.selectMonitorIndexDefault();
    },
    // 统计数值
    changeStatisticsValue: function () {
      // 查询阈值
      tableDefaultAlarmConfigurationWarningVue.selectMonitorIndexDefault();
    },
    // 统计次数
    changeStatisticsCount: function () {
      // 查询阈值
      tableDefaultAlarmConfigurationWarningVue.selectMonitorIndexDefault();
    },
    // 关系符号
    changeRelationshipSign: function () {
      // 查询阈值
      tableDefaultAlarmConfigurationWarningVue.selectMonitorIndexDefault();
    },
    // 监控模块
    changeMonitorModule: function () {
      this.defaultAlarmConfigurationForm.monitorIndex = "";
      if (this.defaultAlarmConfigurationForm.monitorModule == undefined) {
        return;
      }

      // 如果监控模块为账务 显示资源类型
      if (this.defaultAlarmConfigurationForm.monitorModule == 2) {
        this.isBilling = 1;
        tableDefaultAlarmConfigurationWarningVue.searchResourceType();
      } else {
        this.isBilling = "";
        tableDefaultAlarmConfigurationWarningVue.searchMonitorIndex();
      }

      // 如果监控模块为“CloudTrail” 显示事件检查
      if (this.defaultAlarmConfigurationForm.monitorModule == 9) {
        this.queryCloudTrailSecurityEvents();
      }
    },
    // 创建报警
    /**********************************************************************************/
    ok: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var alertList = {
            monitorIndex: this.defaultAlarmConfigurationForm.monitorIndex,
            cycle: this.defaultAlarmConfigurationForm.cycle,
            continousCycle: this.defaultAlarmConfigurationForm.continousCycle,
            statisticsValue: this.defaultAlarmConfigurationForm.statisticsValue,
            statisticsCount: this.defaultAlarmConfigurationForm.statisticsCount,
            relationshipSign:
              this.defaultAlarmConfigurationForm.relationshipSign,
            monitorModule: this.defaultAlarmConfigurationForm.monitorModule,
            customerPriorityId: this.defaultAlarmConfigurationForm.priority,
            resourceType: this.defaultAlarmConfigurationForm.resourceType,
            monitorPeriod: this.defaultAlarmConfigurationForm.monitorPeriod,
            isAutoDelayEnroll:
              this.defaultAlarmConfigurationForm.isAutoDelayEnroll,
            defaultAlarmAccountType: this.defaultAlarmConfigurationForm.types,
            noticeTypes: this.defaultAlarmConfigurationForm.noticeTypes,
          };

          // 如果监控指标为实例健康状态或者系统健康状态
          if (
            this.defaultAlarmConfigurationForm.monitorIndex == 7 ||
            this.defaultAlarmConfigurationForm.monitorIndex == 8
          ) {
            alertList.customerMonitorIndexDefaultValue = 1;
          } else if (this.defaultAlarmConfigurationForm.monitorIndex == 40) {
            alertList.customerMonitorIndexDefaultStringValues =
              this.defaultAlarmConfigurationForm.thresholdValues;
          } else {
            alertList.customerMonitorIndexDefaultValue =
              this.defaultAlarmConfigurationForm.thresholdValue;
          }

          if (this.defaultAlarmConfigurationForm.monitorIndex == 59) {
            alertList.logGroupName = this.logGroupName;
          }

          // 当监控模块为“CloudTrail”时 显示事件检查
          if (this.defaultAlarmConfigurationForm.monitorModule == 9) {
            alertList.cloudTrailNames =
              this.defaultAlarmConfigurationForm.cloudTrailNames;
          }

          // 当指标为"EIP没有EC2attached"、"自动购买预留实例"、"没有EBS attached"、"负载均衡未关联实例"时 传审批流
          if (
            this.defaultAlarmConfigurationForm.monitorIndex == 12 ||
            this.defaultAlarmConfigurationForm.monitorIndex == 35 ||
            this.defaultAlarmConfigurationForm.monitorIndex == 36 ||
            this.defaultAlarmConfigurationForm.monitorIndex == 40
          ) {
            alertList.processTemplateId =
              this.defaultAlarmConfigurationForm.approvalFlow;
          }

          // 添加告警
          tableDefaultAlarmConfigurationWarningVue.$api.customerDefinedAlarmConfiguration
            .createDefaultAlertRule(alertList)
            .then((res) => {
              this.data = res.data;
              setTimeout(() => {
                this.reload();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t("common.addSuccess"));
                this.isBilling = "";
                this.modal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.addFail"));
        }
      });
    },
    // 取消
    cancel: function (name) {
      this.monitorIndexList = [];
      this.isBilling = "";
      this.modal = false;
      this.$refs[name].resetFields();
    },
    // 查询报警方式
    searchAlarmWay: function () {
      tableDefaultAlarmConfigurationWarningVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmWayList = res.data;
        });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/default_alarm_configuration/AddOrUpdateDefaultAlarmConfiguration.vue